import React from 'react';
import { Paper, Typography, List, ListItem, ListItemText, Link as MLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const links = [
  { to: '/', label: 'Home' },
  { to: '/bills', label: 'Bills' },
  { to: '/members', label: 'Members' },
  { to: '/committees', label: 'Committees' },
  { to: '/nominations', label: 'Nominations' },
  { to: '/chat', label: 'AI Chat' },
  { to: '/congress', label: 'Congresses' },
  { to: '/about', label: 'About' },
  { to: '/privacy', label: 'Privacy Policy' },
  { to: '/terms', label: 'Terms & Conditions' },
  { to: '/contact', label: 'Contact Us' },
];

const Sitemap: React.FC = () => {
  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>Sitemap</Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Browse key sections of the site.
      </Typography>
      <List>
        {links.map((l) => (
          <ListItem key={l.to} disableGutters>
            <ListItemText
              primary={
                <MLink component={RouterLink} to={l.to} underline="hover">
                  {l.label}
                </MLink>
              }
            />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};

export default Sitemap;
